import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted } from 'vue'
import { docsTocOpen, docsSidebarOpen, openSidebarLink } from '@/helpers/docs.helper'
import Documentation from './Documentation.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'DocsTOC',
  setup(__props) {

const content = ref()
const fileName = '_Sidebar.md'

function close () {
  docsTocOpen.value = false
  docsSidebarOpen.value = true
}

onMounted(async () => {
  const d = await import(/* webpackChunkName: "documentation" */'./docs')
  const docs = d.default
  content.value = docs.content[fileName]
})

return { __sfc: true,content, fileName, close, Documentation }
}

})